export const sure = 'sûr';

export const notSure = 'pas sûr';

export const subResponseValue = [
  sure,
  notSure,
];
